<template>
    <div class="tool">
        <h3 style="text-align: center;background: #f0f3f3;">科研工具箱</h3>
        <ul class="tool_ul">
            <li><a href="http://www.cytotry.com" target="_blank"><img src="../assets/site_icons/bkbc.png">百科博创</a></li>
            <!-- <li><router-link target="_blank" to="/cytotry"><img src="../assets/site_icons/bkbc.png">百科博创</router-link></li> -->
            <li><router-link to="/exchange/list/0/0"><img src="../assets/site_icons/科研置换.png">科研置换</router-link></li>
            <li><router-link to="/tools"><img src="../assets/site_icons/shiyong.png">实用工具</router-link></li>
            <li><router-link to="/paper/polish"><img src="../assets/site_icons/语言润色.png">翻译润色</router-link></li>
            <li><router-link to="/paper/check"><img src="../assets/site_icons/论文查重.png">论文查重</router-link></li>
            <li><router-link to="/paper/dropWeight"><img src="../assets/site_icons/论文降重.png">论文降重</router-link></li>
            <li><router-link to="/bio-info/list/0"><img src="../assets/site_icons/生信分析.png">生信分析</router-link></li>
            <li><router-link to="/analysis/list/0"><img src="../assets/site_icons/tongji.png">统计分析</router-link></li>
            <li><router-link to="/journal-guide"><img src="../assets/site_icons/图片查重.png">选刊助手</router-link></li>
<!--            <li><router-link to="/graph/list/0"><img src="../assets/site_icons/keyan.png">科研绘图</router-link></li>-->
            <!--        <li><a href="#"><img src="../assets/site_icons/图片查重.png">图片查重</a></li>-->
            <!--        <li><router-link to="/protocol/list/0/0"><img src="../assets/site_icons/实验方案.png">实验方案</router-link></li>-->
            <!--          <li><router-link to="/"><img src="../assets/site_icons/知识共享.png">知识共享</router-link></li>-->
            <li><router-link to="/gpt-tools"><img src="../assets/site_icons/openai.png">AI润色</router-link></li>
            <!-- <li><a href="https://qa.citexs.com/?s=dtxs" target="_blank"><img src="/static/images/adver/citexs.png">AI学术问答</a></li>
            <li><a href="https://ibiling.cn/paper?from=dtsypaper01" target="_blank"><img src="static/images/adver/ibiling_logo.png">AI论文写作</a></li> -->
        </ul>
    </div>
</template>

<script>
import request from "../utils/request";
import {eventBus} from "../main";

export default {
    name: "FunctionSection",
    methods: {
        goChatGPT() {
            if(this.global.account == null) {
                this.$message({
                    message: '请先登录',
                    type: 'warning'
                });
                this.$router.replace('/')
                eventBus.$emit('show-login', '');
                return;
            }
            request({
                url: '/api/user/get_gpt_token',
                method: 'get',
            }).then(r => {
                console.log(r)
                window.open(r);
            });
        }
    }
}
</script>

<style scoped>
.tool {height: 370px;  width: 268px; background: #fff; border: #e8e8e8 1px solid; overflow: hidden; }
.tool h3 { line-height: 54px; border-bottom: #e8e8e8 1px solid; padding:0 20px ;font-size: 18px; font-weight: bold; /*color: #555;*/}
.tool h3 a { float: right; font-size: 16px;font-weight: normal;}
.tool_ul { padding: 13.5px 0px 13.5px 15px;overflow: hidden; }
/* .mt15 .tool_ul { padding-right: 20px;} */
.tool_ul li { width: 80px; line-height: 40px;  float: left;}
.tool_ul li a {
    display: flex;
    flex-direction: column;
    align-items: center;
}
.tool_ul li a img { float: left; margin: 10px 8px 0 0; width: 25px; height: 25px;}
</style>



// WEBPACK FOOTER //
// src/components/FunctionSection.vue